import { FieldType, Model, Schema } from "@core/index";
import { IContactAddress } from "./ContactAddress";
import { IContactEmail } from "./ContactEmail";
import { IContactNumber } from "./ContactNumber";
import { ICountry } from "./Country";
import { ITravelDoc } from "./TravelDoc";

export interface IPerson {
    guid?: string;
    gender?: string;
    prefix?: string;
    firstName?: string;
    lastName?: string;
    localFirstName?: string;
    localLastName?: string;
    memberId?: string;
    birthDate?: number;
    preferredLangauge?: string;
    nationality?: ICountry;
    travelDocs?: ITravelDoc[];
    telephone?: IContactNumber;
    mobile?: IContactNumber;
    email?: IContactEmail;
    address?: IContactAddress;
    isSelected?: boolean;
}

export class Person extends Model implements IPerson {
    public static schema: Schema = new Schema("Person");
    public guid?: string;
    public gender?: string;
    public prefix?: string;
    public firstName?: string;
    public lastName?: string;
    public localFirstName?: string;
    public localLastName?: string;
    public memberId?: string;
    public birthDate?: number;
    public preferredLangauge?: string;
    public nationality?: ICountry;
    public travelDocs?: ITravelDoc[] = [];
    public telephone?: IContactNumber = {};
    public mobile?: IContactNumber = {};
    public email?: IContactEmail = {};
    public address?: IContactAddress = {};

    constructor(values: IPerson) {
        super(Person.schema);
        this.setValues(values);
    }
}

Person.schema.addField("gender").type(FieldType.String);
Person.schema.addField("prefix").type(FieldType.String);
Person.schema.addField("firstName").type(FieldType.String);
Person.schema.addField("lastName").type(FieldType.String);
Person.schema.addField("localFirstName").type(FieldType.String);
Person.schema.addField("localLastName").type(FieldType.String);
Person.schema.addField("memberId").type(FieldType.String);
Person.schema.addField("birthDate").type(FieldType.Number);
Person.schema.addField("nationality").type(FieldType.Object);
Person.schema.addField("travelDocs").type(FieldType.List);
Person.schema.addField("telephone").type(FieldType.Object);
Person.schema.addField("mobile").type(FieldType.Object);
Person.schema.addField("email").type(FieldType.Object);
Person.schema.addField("address").type(FieldType.Object);
Person.schema.freeze();
